import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import LoadTop from '../components/LoadTop';
import BackToTop from '../components/BackToTop';

import HomeEight from "./HomeEight";

// inner pages

import ServiceDetails from "../inner/ServiceDetails";
import AboutUs from "../inner/AboutUs";



import ContactUs from '../inner/ContactUs';

// onepage




function RouterPage() {
    return (
        <div>
            <Router>
                <LoadTop />
                <Routes>
                    {/* <Route path="/" element={<HomeOne />}></Route> */}
                    <Route path="/" element={<HomeEight />}></Route>
                                     
                    <Route path="/services" element={<ServiceDetails />}></Route>
                    
                    <Route path="/about-us" element={<AboutUs />}></Route>
                 
               
            
                    <Route path="/contact" element={<ContactUs />}></Route>
                  
                </Routes>
                <BackToTop />
            </Router>
        </div>
    )
}

export default RouterPage